import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { FinancialServicesSegment } from '../../models/provider';
import { translateRefreshableItemsToScopes } from '../../models/refreshableItem';
import { CommonError } from '../../stores/app-state-errors';
import { ERR_PARAM_REFRESHABLE_ITEMS_INVALID } from '../../utilities/error';
import { ValidateProductParams } from '../../utilities/urlParameters';
import { getInvalidTransactionsRefreshableItems, getTransactionsRefreshableItems } from './common';

const DEFAULT_FINANCIAL_SERVICES_SEGMENTS = [FinancialServicesSegment.PERSONAL];

export const validateParams: ValidateProductParams = (commonParameters, getRawParam) => {
  const errors: CommonError[] = [];

  const { financialServicesSegments } = commonParameters;

  const invalidTransactionsRefreshableItems = getInvalidTransactionsRefreshableItems(
    getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
  );

  if (invalidTransactionsRefreshableItems.length > 0) {
    errors.push(ERR_PARAM_REFRESHABLE_ITEMS_INVALID);
  }

  const transactionRefreshableItems = getTransactionsRefreshableItems(
    getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
  );
  const scope = translateRefreshableItemsToScopes(transactionRefreshableItems);

  return {
    parameters: {
      scope,
      refreshableItems: transactionRefreshableItems,
      financialServicesSegments: financialServicesSegments || DEFAULT_FINANCIAL_SERVICES_SEGMENTS,
    },
    errors,
  };
};
